/* ============
 * News Status Transformer
 * ============
 *
 * The transformer for the newsStatuses.
 */

import Transformer from './transformer';

export default class newsStatusesTransformer extends Transformer {

  static fetch(newsStatuses) {
    return {
      id: newsStatuses.id,
      name: newsStatuses.name,
    };
  }

  static send(newsStatuses) {
    return {
      id: newsStatuses.id,
      name: newsStatuses.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/newsStatus.js